// extracted by mini-css-extract-plugin
export var gif = "_hz-0";